import * as React from "react";

const SmallRRChart = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 49 36">
      <path
        fill="#D9D9D9"
        d="M0 17.952c0-.087.018-.178.052-.259 9.474-23.141 14.752-24.036 24.895 0 .034.081.053.171.053.259 0 .739-1.058.9-1.315.208-8.638-23.3-13.898-22.13-22.335.016-.27.709-1.35.535-1.35-.224"
      ></path>
      <path
        fill="#D9D9D9"
        d="M48.54 17.702a.7.7 0 0 1-.053.26c-9.474 23.14-14.752 24.036-24.895-.002a.7.7 0 0 1-.053-.258c0-.738 1.058-.9 1.315-.208 8.638 23.3 13.898 22.13 22.335-.016.27-.708 1.35-.534 1.35.224"
      ></path>
    </svg>
  );
};

export default SmallRRChart;
